<template>
  <div class="animated fadeIn">
    <div class="page-card-margin row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.create_costs_informs}}</strong>
          </div>
          <div class="card-block">
            <form id="cost-inform" enctype="multipart/form-data" class="form-horizontal">
              <div class="form-group row">
                <div class="col-lg-4 form-group">
                  <label>{{web_texts.date_range}}</label>
                  <div class="input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12">
                    <span class="add-on input-group-addon"><i class="glyphicon glyphicon-calendar fa fa-calendar"></i></span>
                    <input type="text" name="daterange" id="daterange" class="form-control input-lg"/>
                  </div>
                </div>
                <div class="col-lg-3 form-group">
                  <label for="report">{{web_texts.inform_name}}</label>
                  <input type="text" v-model="report" id="report" name="report" class="form-control input-lg" size="1"
                         placeholder="Nom informe">
                </div>
                <div class="col-lg-2 form-group">
                  <div class="col-lg-12">
                    <label for="slave_type">{{web_texts.model_device}}</label>
                    <select v-model="slave_type" id="slave_type" name="slave_type" class="form-control input-lg"
                            size="1" @change="getDeviceNumberAndVariables()">
                      <option disabled value="">{{web_texts.select_model}}</option>
                      <option v-for="slave_type in slave_types" :value="slave_type" v-if="slave_type!=='Irrimation'">
                        {{ slave_type }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3 form-group">
                  <div class="col-lg-12">
                    <label for="chose_device">{{web_texts.device}}</label>
                    <select v-model="device" id="chose_device" name="chose_device" class="form-control input-lg"
                            size="1" :disabled="!slave_type">
                      <option disabled value="">{{web_texts.device}}</option>
                      <option v-for="device in devices" :value="device" v-if="device.type=='CVM' || device.type=='CVMNET' || device.type=='CVMMINI'">{{ device.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="card-footer">
            <div class="offset-lg-4 col-lg-4">
              <button type="submit" @click="createCostReports()" class="btn btn-sm btn-primary" :disabled="spinner_cost_inform"><i class="fa fa-dot-circle-o"></i>{{web_texts.create}}</button>
              <button type="reset" @click="resetCostForm()" class="btn btn-sm btn-danger" :disabled="spinner_cost_inform"><i class="fa fa-ban"></i>Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.costs_inform}}</strong>
          </div>
          <GeneralSpinner v-if="spinner_cost_inform"></GeneralSpinner>
          <div class="card-block" v-else="">
            <vue-good-table :columns="columns" :rows="costs_informs" :paginate="true" :perPage="5">
              <template slot="table-row" slot-scope="props">
                <td>{{ props.row.name }}</td>
                <td>{{ props.row.name_slave }}</td>
                <td>{{ props.row.start_datetime }}</td>
                <td>{{ props.row.end_datetime }}</td>
                <td style="text-align: center">
                  <button type="button" class="btn btn-primary" @click="downloadCostInform(props.row.id)"><i class="fa fa-file-pdf-o"></i></button>
                  <button type="button" class="btn btn-danger" @click="deleteInformApi(props.row.id)"><i class="fa fa-trash-o"></i></button>
                </td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/CostsInform';
  import trans_es from '../translates/es/CostsInform';
  import constants from '../constants'
  import middleware from '../utilities/middlewares'
  import modal from 'vue-strap/src/Modal'
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: '',
    data() {
      return {
        web_texts: { "create_costs_informs": "Crear informe de costes", "date_range": "Rango de fechas", "inform_name": "Nombre del informe", "model_device": "Modelo Disp.", "select_model": "Elige Modelo", "device": "Dispositivo", "create": "Crear", "costs_inform": "Informe de costes" } ,
        system: '',
        report: '',
        slave_types: '',
        slave_type: '',
        devices: '',
        device: '',
        showCostsInformModal: false,
        spinner_cost_inform: true,
        months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
        captions: {'ok_button': 'Seleccionar'},
        shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
        costs_informs: '',
        columns: [
          {
            label: 'Inform Name',
            field: 'name',
            html: true
          },
          {
            label: 'Dispositiu',
            field: 'name_slave',
            html: true
          },
          {
            label: 'Start Date',
            field: 'start_datetime',
            html: true
          },
          {
            label: 'Final Date',
            field: 'end_datetime',
            html: true
          },
          {
            label: 'Actions',
            field: 'actions',
            html: true
          }
        ]

      }
    },
    components: {
      modal,
      GeneralSpinner
    },
    created() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["costs_inform","costs_inform"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      this.system = JSON.parse(localStorage.getItem('system'));
      this.getSlavesType();
      this.getReportsTable();
    },
    mounted(){
      // inicialitzem daterangepicker
      this.initializeDateRangePicker();
    },
    methods: {
      // Llegir models de dispositiu
      getSlavesType() {
        axios.post(constants.ROOT_URL + '/api/v1/slaves_type', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.slave_types = response.data;
        }, (response) => {
          console.log(response);
        });
      },
      // Llegir els dispositius
      getDeviceNumberAndVariables() {
        axios.post(constants.ROOT_URL + '/api/v1/device_name_and_variables', {
          system_id: this.system.id,
          type_slave: this.slave_type,
          client_device: 'd'
        }).then((response) => {
          this.devices = response.data[0];
        }, (response) => {
          console.log(response.data);
        });
      },
      // Llegir els informes de costos
      getReportsTable() {
        axios.post(constants.ROOT_URL + '/api/v1/get_informs', {
          system_id: this.system.id,
          inform_type: 'costs_inform',
          client_device: 'd'
        }).then((response) => {
          this.costs_informs = response.data;
          this.spinner_cost_inform=false;
        }, (response) => {
          console.log(response.data);
        });
      },
      // Crear un informe de costos
      createCostReports() {
        this.spinner_cost_inform=true;
        if(this.report !==null && this.slave_type!=='' && this.device!=='' && document.getElementById('daterange').value!=='-') {
          axios.post(constants.ROOT_URL + '/api/v1/create_inform', {
            system_id: this.system.id,
            inform_type: 'costs_inform',
            slave_name: this.device.name,
            name: this.report,
            date_range: document.getElementById('daterange').value,
            slave_channel: "C"+this.device.ch,
            slave_id: this.device.id,
            client_device: 'd'
          }).then((response) => {
            console.log(response.data);
            this.getReportsTable();
            swal({type: 'success', title: 'Informe creat correctament'})
          }, (response) => {
            console.log(response.data);
          });
        }else{
          this.spinner_cost_inform=false;
          swal({type: 'error', title: 'Falta Informació'})
        }
      },
      // Reiniciar el formulari del informe de costos
      resetCostForm() {
        location.reload();
        // document.getElementById('cost-inform').reset()
      },
      // Descargar un informe de costos en pdf
      downloadCostInform(id) {
        this.spinner_cost_inform=true;
        axios.get(constants.ROOT_URL + "/api/v1/pdf/costs_inform/" + id, {
          responseType: 'arraybuffer',
          client_device: 'd'
        }).then((response) => {
          this.spinner_cost_inform=false;
          var file = new File([response.data], "Cost_Report_"+id+".pdf", {type: "application/pdf"});
          FileSaver.saveAs(file);
        }, (response) => {
          console.log(response.data);
        });
      },
      // Eliminar un informe de costos
      deleteInformApi(id) {
        this.spinner_cost_inform=true;
        console.log("click");
        axios.post(constants.ROOT_URL + '/api/v1/delete_inform', {
          system_id: this.system.id,
          inform_id: id,
          client_device: 'd'
        }).then((response) => {
          console.log(response.data);
          this.getReportsTable();
        }, (response) => {
          console.log(response.data);
        });
      },
      // Funcio per a que funcione el datepicker
      initializeDateRangePicker(){
        $(function() {
          var date = new Date();
          var month = date.getMonth();
          var year = date.getFullYear();
          $('input[name="daterange"]').daterangepicker({
            "timePicker": true,
            "timePicker24Hour": true,
            "timePickerIncrement": 15,
            "locale": {
              "format": "DD/MM/YYYY HH:mm",
              "separator": " - ",
              "applyLabel": "Acceptar",
              "cancelLabel": "Cancel·lar",
              "fromLabel": "Des de",
              "toLabel": "Fins",
              "customRangeLabel": "Custom",
              "weekLabel": "W",
              "daysOfWeek": [
                "dg",
                "dl",
                "dt",
                "dc",
                "dj",
                "dv",
                "ds"
              ],
              "monthNames": [
                "Gener",
                "Febrer",
                "Març",
                "Abril",
                "Maig",
                "Juny",
                "Juliol ",
                "Agost ",
                "Setembre",
                "Octubre",
                "Novembre",
                "Desembre"
              ],
              "firstDay": 1
            },
            "startDate": "1/"+(month+1)+"/"+year+" 00:00",
            "endDate": "28/"+(month+1)+"/"+year+" 00:00"
          })
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// CostsInform.vue?77923efe